import * as React from 'react';
import { ThemeProvider } from '@fluentui/react/lib/Theme';
import { loadTheme } from '@fluentui/style-utilities';
import { CoherenceTheme } from '@coherence-design-system/styles';
import styled from 'styled-components'; 

const StyledThemeProvider = styled(ThemeProvider).attrs(CoherenceTheme)`
  height: 100%;
  display: flex;
  flex-direction: column; 
`;

export function CoherenceThemeProvider({ children }: React.PropsWithChildren<unknown>): React.ReactElement {
  loadTheme(CoherenceTheme);

  return <StyledThemeProvider>{children}</StyledThemeProvider>;
}
